export type Destination = {
  cityEn: string;
  cityFa: string;
  code: string;
  image: string;
  regionEn: string;
  regionFa: string;
  size: 'featured' | 'wide' | 'standard';
};

export const destinations: Destination[] = [
  {
    cityEn: 'Tehran',
    cityFa: 'تهران',
    code: 'IKA',
    image: '/images/dest-tehran.jpg',
    regionEn: 'Iran',
    regionFa: 'ایران',
    size: 'featured',
  },
  {
    cityEn: 'Istanbul',
    cityFa: 'استانبول',
    code: 'IST',
    image: '/images/dest-istanbul.jpg',
    regionEn: 'Turkey',
    regionFa: 'ترکیه',
    size: 'wide',
  },
  {
    cityEn: 'Mashhad',
    cityFa: 'مشهد',
    code: 'MHD',
    image: '/images/dest-mashhad.jpg',
    regionEn: 'Iran',
    regionFa: 'ایران',
    size: 'standard',
  },
  {
    cityEn: 'Isfahan',
    cityFa: 'اصفهان',
    code: 'IFN',
    image: '/images/dest-isfahan.jpg',
    regionEn: 'Iran',
    regionFa: 'ایران',
    size: 'standard',
  },
  {
    cityEn: 'Najaf',
    cityFa: 'نجف',
    code: 'NJF',
    image: '/images/dest-najaf.jpg',
    regionEn: 'Iraq',
    regionFa: 'عراق',
    size: 'wide',
  },
  {
    cityEn: 'Kerman',
    cityFa: 'کرمان',
    code: 'KER',
    image: '/images/dest-kerman.jpg',
    regionEn: 'Iran',
    regionFa: 'ایران',
    size: 'wide',
  },
];

export function destinationsByNetwork(kind: 'domestic' | 'international'): Destination[] {
  return destinations.filter((item) =>
    kind === 'domestic' ? item.regionEn === 'Iran' : item.regionEn !== 'Iran',
  );
}
